(function interceptAddToCart() {
  const originalFetch = window.fetch;
  window.fetch = async function (url, options) {
  const u = typeof url === 'string' ? url : url.url;
    if (u && u.includes('/cart/add')) {
      if (window.RechargePubSub) {
        const originalPublish = window.RechargePubSub.publish;
        window.RechargePubSub.publish = function(eventName, data) {
            if (eventName === 'cart:item:add' && data?.triggerCartOverlay) {
                data = { ...data, triggerCartOverlay: false };
            }
            return originalPublish.call(this, eventName, data);
        };
      }
      const response = await originalFetch.apply(this, arguments);
      return response;
    }

    return originalFetch.apply(this, arguments);
  };
})();